export default __webpack_public_path__ + "static/media/15-laws-growth.55044fca.png";